export enum CandidateVerificationResult {
  CVR_1_0__CAN_BE_EMPLOYED_IMMEDIATELY = 'CVR_1_0__CAN_BE_EMPLOYED_IMMEDIATELY',
  CVR_2_0__CAN_NOT_BE_EMPLOYED = 'CVR_2_0__CAN_NOT_BE_EMPLOYED',
  CVR_3_0__PROCEDURES_REQUIRED_TO_BE_EMPLOYED = 'CVR_3_0__PROCEDURES_REQUIRED_TO_BE_EMPLOYED',
}

export enum CandidateVerificationStatus {
  CVS_1_0_0__STARTED__AWAITING_CANDIDATE_DETAILS = 'CVS_1_0_0__STARTED__AWAITING_CANDIDATE_DETAILS',
  CVS_2_0_0__CANDIDATE_DETAILS_PROVIDED__VERIFICATION_INPROGRESS = 'CVS_2_0_0__CANDIDATE_DETAILS_PROVIDED__VERIFICATION_INPROGRESS',
  CVS_3_0_0__REQUESTED_MORE_CANDIDATE_DETAILS__AWAITING_SUBMISSION = 'CVS_3_0_0__REQUESTED_MORE_CANDIDATE_DETAILS__AWAITING_SUBMISSION',
  CVS_3_0_1__MORE_CANDIDATE_DETAILS_PROVIDED__VERIFICATION_INPROGRESS = 'CVS_3_0_1__MORE_CANDIDATE_DETAILS_PROVIDED__VERIFICATION_INPROGRESS',
  CVS_4_0_0__CANDIDATE_DETAILS_VERIFIED__AWAITING_EMPLOYER_DECISION = 'CVS_4_0_0__CANDIDATE_DETAILS_VERIFIED__AWAITING_EMPLOYER_DECISION',
  CVS_5_0_1__CANDIDATE_VERIFICATION_FINISHED__CANDIDATE_ACCEPTED = 'CVS_5_0_1__CANDIDATE_VERIFICATION_FINISHED__CANDIDATE_ACCEPTED',
  CVS_5_0_2__CANDIDATE_VERIFICATION_FINISHED__CANDIDATE_REJECTED = 'CVS_5_0_2__CANDIDATE_VERIFICATION_FINISHED__CANDIDATE_REJECTED',

  CVS_99_0_0__CANDIDATE_STOPPED_THE_PROCESS = 'CVS_99_0_0__CANDIDATE_STOPPED_THE_PROCESS',
}

// Short numeric codes rendered as a pill next to each status label.
export const CANDIDATE_VERIFICATION_STATUS_PREFIX: Record<CandidateVerificationStatus, string> = {
  [CandidateVerificationStatus.CVS_1_0_0__STARTED__AWAITING_CANDIDATE_DETAILS]: '1',
  [CandidateVerificationStatus.CVS_2_0_0__CANDIDATE_DETAILS_PROVIDED__VERIFICATION_INPROGRESS]: '2',
  [CandidateVerificationStatus.CVS_3_0_0__REQUESTED_MORE_CANDIDATE_DETAILS__AWAITING_SUBMISSION]: '3',
  [CandidateVerificationStatus.CVS_3_0_1__MORE_CANDIDATE_DETAILS_PROVIDED__VERIFICATION_INPROGRESS]: '3.1',
  [CandidateVerificationStatus.CVS_4_0_0__CANDIDATE_DETAILS_VERIFIED__AWAITING_EMPLOYER_DECISION]: '4',
  [CandidateVerificationStatus.CVS_5_0_1__CANDIDATE_VERIFICATION_FINISHED__CANDIDATE_ACCEPTED]: '5.1',
  [CandidateVerificationStatus.CVS_5_0_2__CANDIDATE_VERIFICATION_FINISHED__CANDIDATE_REJECTED]: '5.2',
  [CandidateVerificationStatus.CVS_99_0_0__CANDIDATE_STOPPED_THE_PROCESS]: '6',
};

export const CANDIDATE_VERIFICATION_DECISION_STATUSES = [
  CandidateVerificationStatus.CVS_5_0_1__CANDIDATE_VERIFICATION_FINISHED__CANDIDATE_ACCEPTED,
  CandidateVerificationStatus.CVS_5_0_2__CANDIDATE_VERIFICATION_FINISHED__CANDIDATE_REJECTED,
];

export function isCandidateVerificationDecisionStatus(status: CandidateVerificationStatus | null | undefined): boolean {
  return !!status && CANDIDATE_VERIFICATION_DECISION_STATUSES.includes(status);
}

export function isCandidateVerificationStoppedStatus(status: CandidateVerificationStatus | null | undefined): boolean {
  return status === CandidateVerificationStatus.CVS_99_0_0__CANDIDATE_STOPPED_THE_PROCESS;
}

export function isCandidateVerificationTerminalStatus(status: CandidateVerificationStatus | null | undefined): boolean {
  return isCandidateVerificationDecisionStatus(status) || isCandidateVerificationStoppedStatus(status);
}

export enum CandidateVerificationMode {
  CVM_1_0__EMPLOYER_STARTED = 'CVM_1_0__EMPLOYER_STARTED',
  CVM_2_0__STARTED_BY_EMPLOYEE = 'CVM_2_0__STARTED_BY_EMPLOYEE',
}

export enum VerificationChangeType {
  GENERAL = 'GENERAL',
  VERIFICATION_STARTED = 'VERIFICATION_STARTED',
  BASIC_DETAILS_CHANGE = 'BASIC_DETAILS_CHANGE',
  STATUS_CHANGE = 'STATUS_CHANGE',
  RESULT_CHANGE = 'RESULT_CHANGE',
  CANDIDATE_SUBMITTED_THE_FORM = 'CANDIDATE_SUBMITTED_THE_FORM',
  DOCUMENT_ADDED = 'DOCUMENT_ADDED',
  SMS_WITH_LINK_SENT = 'SMS_WITH_LINK_SENT',
  ERROR_SENDING_SMS_WITH_LINK = 'ERROR_SENDING_SMS_WITH_LINK',
  PIN_AND_LINK_SENT = 'PIN_AND_LINK_SENT',
  ERROR_SENDING_PIN_AND_LINK = 'ERROR_SENDING_PIN_AND_LINK',
  TOKEN_AND_PIN_GENERATED = 'TOKEN_AND_PIN_GENERATED',
  TOKEN_AND_PIN_REGENERATED = 'TOKEN_AND_PIN_REGENERATED',
  SUPPLEMENTARY_INFO_REQUESTED = 'SUPPLEMENTARY_INFO_REQUESTED',
  CANDIDATE_FORM_DEADLINE_EXTENDED = 'CANDIDATE_FORM_DEADLINE_EXTENDED',
  FORM_CHANGES_MADE_MANUALLY = 'FORM_CHANGES_MADE_MANUALLY',
  PROCEDURE_STATUS_CHANGE = 'PROCEDURE_STATUS_CHANGE',
  EXTRA_SERVICE_ADDED = 'EXTRA_SERVICE_ADDED',
  CONSULTANT_VERIFICATION_DECISION_CHANGED = 'CONSULTANT_VERIFICATION_DECISION_CHANGED',

  CANDIDATE_EXTENDED_FORM_VALIDITY = 'CANDIDATE_EXTENDED_FORM_VALIDITY',
  CANDIDATE_STOPPED_PROCESS_VIA_SMS = 'CANDIDATE_STOPPED_PROCESS_VIA_SMS',
}

export enum CandidateProcedureStatus {
  CPS_1_0_0__AWAITING_EMPLOYER_DECISION = 'CPS_1_0_0__AWAITING_EMPLOYER_DECISION',
  CPS_2_0_0__STARTED = 'CPS_2_0_0__STARTED',
  CPS_3_0_1__REJECTED = 'CPS_3_0_1__REJECTED',
  CPS_3_0_2__CANCELLED = 'CPS_3_0_2__CANCELLED',
}

export enum CandidateDetailsFormType {
  BASE = 'BASE',
  SUPPLEMENTARY = 'SUPPLEMENTARY',
}

export enum FileCategory {
  CITIZENSHIP_CONFIRMATION = 'CITIZENSHIP_CONFIRMATION',
  COUNTRY_OF_STAY_LEGAL_DOCS = 'COUNTRY_OF_STAY_LEGAL_DOCS',
  SCHENGEN_VISA = 'SCHENGEN_VISA',
  STUDENT_STATUS_CONFIRMATION = 'STUDENT_STATUS_CONFIRMATION',
  GRADUATION_DIPLOMA = 'GRADUATION_DIPLOMA',
  SPOUSE_LEGAL_STAY_DOCUMENT = 'SPOUSE_LEGAL_STAY_DOCUMENT',
  REFUGEE_STATUS_DOCUMENT = 'REFUGEE_STATUS_DOCUMENT',
  POLES_CARD = 'POLES_CARD',
  LONG_TERM_OR_PERM_STAY_PERMIT = 'LONG_TERM_OR_PERM_STAY_PERMIT',
  TEMP_STAY_PERMIT = 'TEMP_STAY_PERMIT',
  CONFIRMATION_OF_APPLICATION_FOR_TEMP_PERMIT = 'CONFIRMATION_OF_APPLICATION_FOR_TEMP_PERMIT',
  SUPPLEMENTARY_INFORMATION = 'SUPPLEMENTARY_INFORMATION',
  OTHER = 'OTHER',
}

export interface CandidateDetailsFormExtensionHistoryEntry {
  extendedAt: Date;
  extendedBy: 'manager' | 'consultant' | 'candidate';
  oldValidUntil: Date;
  newValidUntil: Date;
}
